import classNames from 'classnames';
import type {ReactNode} from 'react';
import {Component} from 'react';

interface Props {
    src: string;
    srcset?: string;
    sizes?: string;
    alt?: string;
    className?: string;
}

interface State {
    loaded: boolean;
}

export default class Image extends Component<Props, State> {
    public static defaultProps = {
        className: '',
    };

    public readonly state: State = {
        loaded: false,
    };

    private readonly handleLoad = (): void => {
        this.setState({
            loaded: true,
        });
    };

    public render(): ReactNode {
        const classes = classNames({
            'r-img': true,
            'r-img_shown': this.state.loaded,
        });

        return (
            <div className={classes}>
                <img
                    src={this.props.src}
                    srcSet={this.props.srcset}
                    sizes={this.props.sizes}
                    alt={this.props.alt}
                    onLoad={this.handleLoad}
                    className={`r-img--img ${this.props.className}`}
                    loading="lazy"
                />
            </div>
        );
    }
}
